import script from "./IssueCard.vue?vue&type=script&setup=true&lang=js"
export * from "./IssueCard.vue?vue&type=script&setup=true&lang=js"

import "./IssueCard.vue?vue&type=style&index=0&id=2f72089e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f72089e"]])

export default __exports__